// extracted by mini-css-extract-plugin
export default {"align-cc":"Home_align-cc__8yTHQ","align-lc":"Home_align-lc__GZ0hS","align-rc":"Home_align-rc__AkpqT","home":"Home_home__eZH5H"};